import PropTypes from "prop-types"
import classNames from "classnames"

import { IconButton } from "@mui/material"
import { StarBorder, Star } from "@mui/icons-material"
import Tooltip from "components/material/tooltip"

export default function FavoriteToggleButton({ isFavorite, handleToggleFavorite }) {
  return <Tooltip title={!isFavorite ? "Add to favorites" : "Remove from favorites"}>
    <IconButton
      onClick={handleToggleFavorite}
      className={classNames("favorite-resource", { active: !!isFavorite })}
      size="large"
    >
      {!isFavorite ? <StarBorder /> : <Star />}
    </IconButton>
  </Tooltip>
}

FavoriteToggleButton.propTypes = {
  isFavorite: PropTypes.bool.isRequired,
  handleToggleFavorite: PropTypes.func.isRequired,
}
